import { isArray, isFunction, isObject, type } from "@jd/jmtd-tools/es/is";

var deepEqual = function deepEqual(x, y) {
  if (type(x) !== type(y)) {
    return false;
  }

  if (isObject(x)) {
    if (Object.keys(x).length !== Object.keys(y).length) {
      return false;
    }

    for (var key in x) {
      if (!deepEqual(x[key], y[key])) {
        return false;
      }
    }
  } else if (isArray(x)) {
    if (x.length !== y.length) {
      return false;
    }

    for (var index = 0; index < x.length; index++) {
      if (!deepEqual(x[index], y[index])) {
        return false;
      }
    }
  } else if (isFunction(x)) {
    // 滤对函数的深比较
    return true;
  } else {
    // 其它类型值比较
    return x === y;
  }

  return true;
};

export default deepEqual;